<template>
	<div class="card main">
		<nav>
			<div class="nav-wrapper indigo darken-3">
				<a
				 href="#"
				 class="brand-logo center"
				>Авторизация</a>
			</div>
		</nav>
		<div class="card-content">
			<form class="row">
				<div
				 class="input-field col s12"
				 v-if="!restorePassword"
				>
					<input
					 type="text"
					 id="autocomplete-login"
					 @input="setLogin($event)"
					 :style="($v.login.$dirty && !$v.login.required)
							                    ? 'border-bottom: 1px solid #d32f2f; box-shadow: 0 1px 0 #d32f2f'
							                    : null"
					 autocomplete="off"
					 class="autocomplete"
					>
					<label
					 for="autocomplete-login"
					 :style="($v.login.$dirty && !$v.login.required)
							                    ? 'color: #d32f2f;'
							                    : null"
					>
						Логин
					</label>
					<error-in-auth :field="$v.login" />
				</div>
				<div
				 class="input-field col s12"
				 v-if="!restorePassword"
				>
					<input
					 type="password"
					 id="autocomplete-pass"
					 @input="setPass($event)"
					 :style="($v.pass.$dirty && !$v.pass.required)
							                    ? 'border-bottom: 1px solid #d32f2f; box-shadow: 0 1px 0 #d32f2f'
							                    : null"
					 autocomplete="off"
					 class="autocomplete"
					>
					<label
					 for="autocomplete-pass"
					 :style="($v.pass.$dirty && !$v.pass.required)
							                    ? 'color: #d32f2f;'
							                    : null"
					>
						Пароль
					</label>
					<error-in-auth :field="$v.pass" />
				</div>
				<div
				 class="input-field col s12"
				 v-if="restorePassword"
				>
					<input
					 type="text"
					 id="restore-pass"
					 autocomplete="off"
					 v-model="numberPhone"
					 class="autocomplete"
					>
					<label for="restore-pass">
						Номер телефона (формат: +79211234567)
					</label>
					<error-in-auth :field="$v.login" />
				</div>
				<button
				 class="waves-effect waves-light btn blue darken-3"
				 v-if="restorePassword"
				 type="button"
				 @click.prevent="forgotPass"
				>
					<i class="material-icons">keyboard_arrow_left</i>
				</button>
				<button
				 class="waves-effect waves-light btn right blue darken-3"
				 v-if="restorePassword"
				 @click.prevent="restorePass"
				>восстановить пароль
				</button>
				<button
				 class="waves-effect waves-light btn blue darken-3"
				 v-if="!restorePassword"
				 type="button"
				 @click.prevent="forgotPass"
				>забыл пароль
				</button>
				<button
				 class="waves-effect waves-light btn right indigo darken-3"
				 @click.prevent="submit"
				 v-if="!restorePassword"
				 :class="{disabled: $v.$invalid}"
				>войти
				</button>
			</form>
		</div>
	</div>
</template>
<script>
	import Auth from "../../plugins/controllers/auth";
	import restorePassFromAPI from "../../plugins/controllers/restorePass";
	import { eventEmitter } from "../../main";
	import { mapMutations } from "vuex";
	import { required } from "vuelidate/lib/validators";
	import ErrorInAuth from "./errorInAuth";
	import setRules from "../../assets/setRules";
	import preload from "../../assets/preload";

	export default {
		name: "Auth",
		components: { ErrorInAuth },
		data() {
			return {
				login: "",
				pass: "",
				restorePassword: false,
				numberPhone: ""
			};
		},
		validations: {
			login: {
				required
			},
			pass: {
				required
			}
		},
		methods: {
			...mapMutations([
				"setMenu",
				"setLoginState",
				"setAuth",
				"setShowMenu",
				"setShowVerificateForm",
				"setTokenSuccess",
				"setRole",
				"setAppendLogin"
			]),
			setLogin(event) {
				this.login = event.target.value;
				this.$v.login.$touch();
			},
			setPass(event) {
				this.pass = event.target.value;
				this.$v.pass.$touch();
			},
			forgotPass() {
				this.restorePassword = !this.restorePassword;
			},
			async restorePass() {
				let a = this.numberPhone;
				a = a.trim().replace("+", "");
				let arrNum = Array.from(a);
				if (arrNum[0] === "8") {
					arrNum.splice(0, 1);
					arrNum.unshift(7);
				} else if (arrNum[0] === "9") {
					arrNum.unshift(7);
				}
				try {
					let res = await restorePassFromAPI(arrNum.join(""));
					if (!res || res.data.code === 500) {
						this.$toast.error({
							title: "Возникли проблемы",
							message: "Попробуйте снова"
						});
					} else if (res.data.code === 200) {
						this.$toast.success({
							title: "Пароль изменен",
							message: "Новый пароль придет на ваш номер телефона"
						});
						this.forgotPass();
					} else if (res.data.code === 404) {
						this.$toast.error({
							title: "В нашей базе отсутствует данный номер",
							message: "Уточните данные и попробуйте снова"
						});
					}
				} catch (e) {
					this.$toast.error({
						title: "Возникли проблемы",
						message: "Попробуйте снова"
					});
				}
			},
			submit() {
				if (!this.$v.$invalid) {
					// preload.show();
					// if (window.dispatchEvent) {
					// 	window.dispatchEvent(window.showPreload)
					// }
					Auth(this.login, this.pass)
						.then(res => {
							console.log(res);
							// if (window.dispatchEvent) {
							// 	window.dispatchEvent(window.hiddenPreload)
							// }

							if (res.data && res.data.success) {
								setRules(res);
								localStorage.setItem("login", this.login);
								localStorage.setItem(
									"role",
									res.headers["x-user-type"]
								);
								this.setLoginState(this.login);
								this.setMenu();
								this.setAuth(false);
								this.setShowMenu(true);
								eventEmitter.$emit("tokenSuccess");
								this.setTokenSuccess(true);
								setTimeout(() => {
									document
										.querySelector("#nav-mobile")
										.classList.remove("nav-show");
								}, 400);
								if (res.headers["x-user-type"] === "user") {
									// this.$router.push(`/playlist/${localStorage.getItem("login")}`);
									this.$router.push("/account");
								} else if (res.headers["x-user-type"] === "root") {
									this.$router.push(`/account`);
								} else if (res.headers["x-user-type"] === "admin") {
									this.$router.push(`/account`);
								}
							} else if (
								res.data &&
								!res.data.success &&
								res.data.message === "need verification"
							) {
								setRules(res);
								localStorage.setItem("login", this.login);
								this.setLoginState(this.login);
								this.setMenu();
								this.setAuth(false);
								this.setShowVerificateForm(true);
								this.$toast.warn({
									title: "Требуется верификация вашего телефона",
									message:
										"введите ваш номер, на который будет отпралено SMS"
								});
							} else {
								this.$toast.error({
									title: "Не верные логин или пароль",
									message: "Уточните данные и повторите вход"
								});
							}
						})
						.catch(e => {
							console.log("Auth", e);
							if (window.dispatchEvent) {
								window.dispatchEvent(window.hiddenPreload);
							}
							if (e.message.toLowerCase() === "network error") {
								this.$toast.error({
									title: "Ошибка с соединением",
									message:
										"Проблемы с интернет-подключением или с доступом к серверу"
								});
							} else if (
								e.message.toLowerCase() ===
								"request failed with status code 500"
							) {
								this.$toast.error({
									title:
										"Ваша учетная запись скорее всего отключена",
									message:
										"Уточните данные у администратора сервиса"
								});
							} else {
								this.$toast.error({
									title: "Не верные логин или пароль",
									message: "Уточните данные и повторите вход"
								});
							}
						})
						.then(() => {
							// preload.hidden()
						});
				}
			}
		}
	};
</script>
<style scoped lang="scss">
	.brand-logo {
		font-size: 22px;
	}

	form {
		margin: 0;
	}

	input[type="text"],
	input[type="password"] {
		&:not(.browser-default):focus:not([readonly]) {
			border-bottom: 1px solid #4d5ff1;
			box-shadow: 0 1px 0 #4c5edf;
		}

		&:not(.browser-default):focus:not([readonly]) + label {
			color: #4d5ff1;
		}
	}

	.main {
		position: absolute;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
		width: 98%;
		overflow: hidden;
	}

	@media screen and (min-width: 550px) {
		.main {
			width: 400px;
		}
	}

	@media screen and (min-width: 1200px) {
		.main {
			width: 600px;
		}
	}
</style>
